import _ from 'lodash'
import { serviceV2 } from '@/utils/request'

const prefix = '/resume-vector'

const streamingCallbackFunc = [
  'onStart', 'onProgress', 'onEnd', 'onError'
]
function asStreamAble (url, params) {
  const streaming = params.streaming
  if (streaming) {
    let _resolve, _reject
    const promise = new Promise((resolve, reject) => {
      _resolve = resolve
      _reject = reject
    })

    const query = new URLSearchParams()
    _.forEach(params, (val, key) => {
      if (!streamingCallbackFunc.includes(key)) {
        query.set(key, val)
      }
    })
    const queryStr = query.toString()
    url = queryStr ? `${url}?${queryStr}` : url
    url = serviceV2.defaults.baseURL + url

    const eventSource = new EventSource(url)
    eventSource.onopen = (e) => {
      params.onStart?.(e)
    }
    eventSource.onmessage = (e) => {
      const data = JSON.parse(e.data)

      if (data.type === 'end') {
        try {
          _resolve()
          params.onEnd?.(data)
        } finally {
          eventSource.close()
        }
      } else {
        params.onProgress?.(data)
      }
    }
    eventSource.onerror = (e) => {
      try {
        _reject()
      } finally {
        eventSource.close()
      }
    }
    return promise
  } else {
    return serviceV2.get(url, { params })
  }
}

export default {
  getSimilarApplication (params) {
    return serviceV2.post(`${prefix}/application/similarity/`, params)
  },
  getSimilarTalent (params) {
    return serviceV2.post(`${prefix}/talent/similarity/`, params)
  },
  getApplicationSimilaritySummary (params) {
    return asStreamAble(`${prefix}/application/similarity/summary/`, params)
  },
  getTalentSimilaritySummary (params) {
    return asStreamAble(`${prefix}/talent/similarity/summary/`, params)
  }
}
